import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String } // the text to copy

  async copy(event) {
    event.preventDefault()
    const button = this.element

    if (!this.hasTextValue || !this.textValue) return

    try {
      await navigator.clipboard.writeText(this.textValue)
      
      button.classList.add('copied')
      
      setTimeout(() => {
        button.classList.remove('copied')
      }, 1000)
    } catch (err) {
      console.error("Clipboard copy failed:", err)
      this.showCopyError(button)
    }
  }
  
  showCopyError(button) {
    const originalText = button.textContent
    button.textContent = "Copy failed"
    button.classList.add("text-danger")
    button.classList.remove("text-info")
    
    setTimeout(() => {
      button.textContent = originalText
      button.classList.remove("text-danger")
      button.classList.add("text-info")
    }, 2000)
  }
}
